import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NewsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('todas');
  const [selectedNews, setSelectedNews] = useState<any>(null);

  const categories = [
    { id: 'todas', name: 'Todas las Noticias', count: 12 },
    { id: 'empresa', name: 'Empresa', count: 4 },
    { id: 'proyectos', name: 'Proyectos', count: 5 },
    { id: 'tecnologia', name: 'Tecnología', count: 3 }
  ];

  const newsItems = [
    {
      id: 1,
      title: 'DavidCorp anuncia expansión a nuevos mercados latinoamericanos',
      excerpt: 'La empresa líder en ingeniería industrial anuncia planes para expandirse a Colombia y Chile en 2024.',
      date: '15 Feb 2026',
      category: 'empresa',
      image: 'próximamente',
      content: 'DavidCorp S.R.L. anunció hoy sus planes de expansión a nuevos mercados en Latinoamérica, específicamente en Colombia y Chile, como parte de su estrategia de crecimiento internacional para el periodo 2024-2026...'
    },
    {
      id: 2,
      title: 'Nuevo contrato para planta de procesamiento mineral en Arequipa',
      excerpt: 'DavidCorp firma contrato por $50 millones para construcción de planta de procesamiento en Arequipa.',
      date: '10 Feb 2026',
      category: 'proyectos',
      image: 'próximamente',
      content: 'Se firmó un contrato importante para la construcción de una planta de procesamiento mineral en la región de Arequipa, con una inversión inicial de $50 millones...'
    },
    {
      id: 3,
      title: 'Innovación en sostenibilidad: Nuevos métodos de construcción ecológica',
      excerpt: 'La empresa lidera iniciativas de construcción sostenible con nuevas tecnologías.',
      date: '05 Feb 2026',
      category: 'tecnologia',
      image: 'próximamente',
      content: 'DavidCorp ha implementado nuevas tecnologías en sus procesos de construcción que reducen el impacto ambiental en un 40%...'
    },
    {
      id: 4,
      title: 'DavidCorp recibe premio a la excelencia en seguridad industrial',
      excerpt: 'Reconocimiento por cero accidentes laborales durante 24 meses consecutivos.',
      date: '28 Ene 2026',
      category: 'empresa',
      image: 'próximamente',
      content: 'La empresa fue reconocida por la Asociación Peruana de Seguridad Industrial por mantener cero accidentes laborales durante 24 meses consecutivos...'
    },
    {
      id: 5,
      title: 'Implementación de IA en procesos de ingeniería',
      excerpt: 'DavidCorp adopta inteligencia artificial para optimizar procesos de diseño y construcción.',
      date: '20 Ene 2026',
      category: 'tecnologia',
      image: 'próximamente',
      content: 'La empresa ha comenzado a implementar soluciones de inteligencia artificial para optimizar sus procesos de diseño y construcción...'
    },
    {
      id: 6,
      title: 'Participación en feria internacional de ingeniería',
      excerpt: 'DavidCorp exhibe sus soluciones innovadoras en la Feria Internacional de Ingeniería en Lima.',
      date: '15 Ene 2026',
      category: 'empresa',
      image: 'próximamente',
      content: 'La empresa participó en la Feria Internacional de Ingeniería en Lima, donde presentó sus soluciones más innovadoras...'
    }
  ];

  const filteredNews = selectedCategory === 'todas' 
    ? newsItems 
    : newsItems.filter(news => news.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 page-top-spacing">
      <div className="container-standard px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-display font-bold text-primary-dark mb-4">Noticias y Actualizaciones</h1>
          <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
          <p className="mt-6 text-body-lg text-gray-600 max-w-3xl mx-auto">
            Mantente informado sobre las últimas noticias, proyectos y logros de DavidCorp S.R.L.
          </p>
        </motion.div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <motion.button
              key={category.id}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                selectedCategory === category.id
                  ? 'bg-primary-dark text-white shadow-lg'
                  : 'bg-white text-primary-dark hover:bg-gray-100 border border-gray-200'
              }`}
              onClick={() => setSelectedCategory(category.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {category.name} 
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${
                selectedCategory === category.id
                  ? 'bg-white bg-opacity-20'
                  : 'bg-primary-accent bg-opacity-20'
              }`}>
                {category.count}
              </span>
            </motion.button>
          ))}
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredNews.map((news, index) => (
            <motion.article
              key={news.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 card-elevated"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
            >
              <div className="h-56 bg-gray-200 overflow-hidden">
                {news.image === 'próximamente' ? (
                  <div className="h-full w-full flex items-center justify-center text-gray-500 bg-gray-100">
                    <div className="text-center p-4">
                      <div className="text-4xl mb-2">🚧</div>
                      <p className="text-sm font-medium">Próximamente</p>
                    </div>
                  </div>
                ) : (
                  <img
                    src={news.image}
                    alt={news.title}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <span className="px-3 py-1 bg-primary-accent bg-opacity-10 text-primary-accent rounded-full text-xs font-semibold">
                    {news.category.charAt(0).toUpperCase() + news.category.slice(1)}
                  </span>
                  <span className="text-gray-500 text-sm">{news.date}</span>
                </div>
                <h2 className="text-subheading font-bold text-primary-dark mb-3">{news.title}</h2>
                <p className="text-gray-600 mb-4">{news.excerpt}</p>
                <button
                  onClick={() => setSelectedNews(news)}
                  className="text-primary-accent font-medium hover:underline"
                >
                  Leer más →
                </button>
              </div>
            </motion.article>
          ))}
        </div>

        {/* Newsletter Subscription */}
        <motion.div 
          className="mt-16 bg-gradient-to-r from-primary-dark to-primary-accent rounded-2xl shadow-xl p-8 text-white"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h2 className="text-heading font-bold mb-4 text-center">Suscríbete a nuestro Boletín</h2>
          <p className="text-center mb-6 max-w-2xl mx-auto">
            Recibe las últimas noticias, proyectos y actualizaciones directamente en tu bandeja de entrada.
          </p>
          <div className="max-w-md mx-auto flex">
            <input
              type="email"
              placeholder="Tu correo electrónico"
              className="flex-grow px-4 py-3 rounded-l-lg text-gray-800 outline-none"
            />
            <button className="bg-primary-accent hover:bg-[#507d9c] text-white font-medium py-3 px-6 rounded-r-lg transition duration-300">
              Suscribirse
            </button>
          </div>
        </motion.div>

        {/* News Details Modal */}
        <AnimatePresence>
          {selectedNews && (
            <motion.div
              className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedNews(null)}
            >
              <motion.div
                className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
                initial={{ scale: 0.9, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                exit={{ scale: 0.9, y: 20 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
                  <h3 className="text-xl font-bold text-primary-dark">{selectedNews.title}</h3>
                  <button
                    onClick={() => setSelectedNews(null)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="p-6">
                  <div className="mb-6">
                    <div className="h-64 bg-gray-100 rounded-xl flex items-center justify-center">
                      {selectedNews.image === 'próximamente' ? (
                        <div className="text-center p-4">
                          <div className="text-4xl mb-2">🚧</div>
                          <p className="text-sm font-medium">Próximamente</p>
                        </div>
                      ) : (
                        <img
                          src={selectedNews.image}
                          alt={selectedNews.title}
                          className="w-full h-full object-cover rounded-xl"
                        />
                      )}
                    </div>
                  </div>

                  <div className="flex items-center gap-4 mb-6">
                    <span className="px-3 py-1 bg-primary-accent bg-opacity-10 text-primary-accent rounded-full text-sm font-semibold">
                      {selectedNews.category.charAt(0).toUpperCase() + selectedNews.category.slice(1)}
                    </span>
                    <span className="text-gray-500 text-sm">{selectedNews.date}</span>
                  </div>

                  <div className="mb-6">
                    <h4 className="font-bold text-primary-dark mb-3">Contenido Completo</h4>
                    <p className="text-gray-700 leading-relaxed">{selectedNews.content}</p>
                  </div>

                  <div className="mt-8 flex justify-end">
                    <button
                      onClick={() => setSelectedNews(null)}
                      className="bg-primary-dark hover:bg-[#0d1c32] text-white font-medium py-3 px-6 rounded-lg transition duration-300"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default NewsPage;